import type { ReactNode } from 'react'
import Icon from '../components/Icon'
import { tw } from './strings'

/** An outlined button that says "Back" and goes one screen up. */
export function BackButton({ onBack }: { onBack: () => void }) {
  return (
    <button type="button" className="w-back-btn" onClick={onBack}>
      <Icon name="back" size={18} /> <span>{tw('w.nav.back')}</span>
    </button>
  )
}

/**
 * A screen's heading with Back on the same row, at the right.
 *
 * The right edge is the column's, so it lines up with the panel below.
 * With no heading it is just Back, right-aligned.
 */
export default function BackRow({ onBack, children }: { onBack: () => void; children?: ReactNode }) {
  return (
    <div className="w-heading-row">
      {children}
      <BackButton onBack={onBack} />
    </div>
  )
}
